<template>
  <div>
    <v-icon 
      dark
      title="Exportação para Excel" 
      @click="abrirDialog()"
    >
      $Excel
    </v-icon>

    <SysDialog
      v-model="dialog"
      titulo="Exportação para Excel"
      txtBotao="Exportar"
      :largura="500"
      @click:primary="exportarExcel()"
      @click:hidden-dialog="fecharDialog()"
    >
      <v-alert
        v-if="ativar_alert"
        border="left"
        color="red"
        icon="mdi-alert"
        type="error"
      >
        Verifique se todos os campos estão preenchidos!
      </v-alert>

      <SysDatePicker 
        v-model="data_inicial"
        titulo_label="Data da Inicial"
        outlined
        :clearable="false"
        :data_maxima="DATA_ATUAL"
      />

      <SysDatePicker 
        v-model="data_final"
        titulo_label="Data da Final"
        outlined
        :clearable="false"
        :data_minima="data_inicial"
        :data_maxima="DATA_ATUAL"
        :error-messages="DATA_FINAL_ERRORS"
      />
    </SysDialog>  
  </div>
</template>

<script setup>
import{ ref, computed, watch } from 'vue';
import Api from '@/api/api.js'
import moment from 'moment';
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue';
import SysDatePicker from '../SysDatePicker.vue';

const props = defineProps({
  filtros: Object,
  headers: String,
  url_relatorio: String,
});

const dialog = ref(false);
const ativar_alert = ref(false);
const data_inicial = ref('');
const data_final = ref(moment().format('YYYY-MM-DD'));
const VERIFICADOR = computed(() => DATA_FINAL_ERRORS.value.length === 0 && data_inicial.value !== '' && data_final.value !== '');
const DATA_ATUAL = computed(() => moment().format('YYYY-MM-DD'));
const DATA_FINAL_ERRORS = computed(() => {
  const errors = [];
  if (data_final.value < data_inicial.value) {
    errors.push('Data final deve ser maior que a inicial!');
  }
  return errors;
});

watch(props, (valor) => {
  data_inicial.value = moment(valor.filtros.data_referencia, "DD-MM-YYYY").startOf('month').format('YYYY-MM-DD');
  data_final.value = moment(valor.filtros.data_referencia, "DD-MM-YYYY").endOf('month').format('YYYY-MM-DD');
});
watch(data_inicial, () => ativar_alert.value = false);
watch(data_final, () => ativar_alert.value = false);

function abrirDialog() {
  dialog.value = true;
}

function fecharDialog() {
  ativar_alert.value = false;
  dialog.value = false;
}

function exportarExcel() {
  const base_url = Api.defaults.baseURL;

  let url = `${base_url}/${props.url_relatorio}`

  if (VERIFICADOR.value) {    
    url += `?data_inicial=${data_inicial.value}`;
    url += `&data_final=${data_final.value}`;
    url += `&headersExcel=${props.headers}`;

    Object.keys(props.filtros).forEach(el => url += `&${el}=${props.filtros[el]}`);

    fecharDialog();    
    window.open(url, "_blank");    
  } else {
    ativar_alert.value = true;
  }
}
</script>